import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { DeleteSocialNetwork, GetSocialNetworks } from '../../fetchs';
import { Link } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AlertDialog from '../Prompt/alert-dialog.component';
import CircularProgress from '@material-ui/core/CircularProgress';

import './socialnetwork-list.styles.css';

const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'نام' },
  { id: 'address', numeric: false, disablePadding: true, label: 'آدرس' },
  { id: 'logo', numeric: false, disablePadding: true, label: 'لوگو' },
  { id: 'tools', numeric: false, disablePadding: true, label: '' }
];

export default class SocialNetworkList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: [],
      alertDialog: false,
      deleteId: null,
      loading: false,
    }
  }

  componentDidMount() {
    this.getSocialNetworks();
  }

  getSocialNetworks = () => {
    this.setState({ loading: true });

    GetSocialNetworks()
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      }).then(responseJson => {
        this.setState({ rows: responseJson });
      }).catch(error => {
        this.setState({ loading: false });
        console.error(error);
      })
  }

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteSocialNetwork(this.state.deleteId)
      .then(response => {
        this.setState({ loading: false });
        if (response.status === 200)
          this.getSocialNetworks();
        return response.json();
      })
      .then(responseJson => {

      })
      .catch(error => {
        console.error(error);
      })
  }

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  }

  render() {
    return (
      <div className="root">
        <Paper className="paper">
          <Toolbar>
            <Grid item xs={12} sm={4}>
              <div className="title">
                {(
                  <Typography variant="h6" id="tableTitle">
                    لیست شبکه های اجتماعی
                </Typography>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={6}></Grid>
            <Grid item xs={12} sm={2}>
              <Link to="/main/socialnetwork" className="link">
                <Button variant="contained" color="primary">ساخت شبکه اجتماعی جدید</Button>
              </Link>
            </Grid>
          </Toolbar>
          <div className="tableWrapper">
            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={'medium'}
            >
              <TableHead>
                <TableRow>
                  {headCells.map(headCell => (
                    <TableCell
                      key={headCell.id}
                      align={'center'}
                      padding={headCell.disablePadding ? 'none' : 'default'}
                    >
                      <TableSortLabel
                        active={false}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.rows.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                    >
                      <TableCell align="center">{row.name}</TableCell>
                      <TableCell align="center">{row.address}</TableCell>
                      <TableCell align="center">{row.logo}</TableCell>
                      <TableCell align="center" style={{ width: '105px' }}>
                        <Link to={`/main/socialnetwork/${row.socialNetworkId}`}>
                          <EditIcon color="primary" />
                        </Link>
                        <DeleteIcon
                          className="deleteIcon"
                          onClick={() => this.handlePrepareDelete(row.socialNetworkId)} />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {this.emptyRows > 0 && (
                  <TableRow style={{ height: 49 * this.emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && <CircularProgress size={24} className="buttonProgress" />}
        </Paper>
        <AlertDialog
          open={this.state.alertDialog}
          title={`اخطار`}
          body={`آیا از حذف شبکه اجتماعی اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog} />
      </div>
    )
  };
}